module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/zh-hans/4/5-945d4c2c970a0c5fd167195e42564015.jpg";